import axiosInstance from "./axiosInstance";

const monthlyVoucherService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/monthly/voucher/create', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/monthly/voucher/create', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchMonthlyDetails: async (payload) => {
        try {
            const response = await axiosInstance.post('/monthly/voucher/monthly/details', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/monthly/voucher/all');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchAllCustomers: async () => {
        try {
            const response = await axiosInstance.get('/monthly/voucher/allCustomersVouchers');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchAllSuppliers: async () => {
        try {
            const response = await axiosInstance.get('/monthly/voucher/allSupplierVouchers');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchMonthlyCustomerDetails: async (payload) => {
        try {
            const response = await axiosInstance.post('/monthly/voucher/monthly/customerdetails', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    createCustomer: async (payload) => {
        try {
            const response = await axiosInstance.post('/monthly/voucher/customer/create', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    createSupplier: async (payload) => {
        try {
            const response = await axiosInstance.post('/monthly/voucher/supplier/create', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchMonthlySupplierDetails: async (payload) => {
        try {
            const response = await axiosInstance.post('/monthly/voucher/monthly/supplierdetails', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
}

export default monthlyVoucherService